{
    "ControlsAgentButtonTitle": "Alle verfügbaren Steuerelemente für den Agenten anzeigen",
    "ControlsDeviceButtonTitle": "Zeigen Sie alle verfügbaren Steuerelemente für das Gerät an",
    "NAME": "StaticAgentControls"
}